/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

// src/api.js
import axios from "axios";

function getTenantSlug() {
  try {
    // ✅ First: use fluxonix_user if available
    const rawUser = localStorage.getItem("fluxonix_user");
    if (rawUser) {
      const parsedUser = JSON.parse(rawUser);
      if (parsedUser?.tenant_slug) {
        return parsedUser.tenant_slug;
      }
    }

    // ✅ Then fallback to inferred_slug
    const inferred = sessionStorage.getItem("inferred_slug");
    if (inferred) return inferred;

  } catch (err) {
    console.warn("⚠️ Unable to parse tenant_slug:", err);
  }

  return null; // final fallback
}

export const api = axios.create({
  baseURL: "",
});

api.interceptors.request.use((config) => {
  // Prefer LPO token if present, otherwise fall back to fluxonix_token
  const lpoToken = localStorage.getItem("lpo_token");
  const userToken = localStorage.getItem("fluxonix_token");
  const token = lpoToken || userToken;
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...config.headers,    
  };

  // 🔴 Do NOT send tenant slug for OTP
  const isOtpRequest = config.url?.includes("/auth/send-otp");
    if (!isOtpRequest) {
    const tenantSlug = getTenantSlug({ allowNull: true });
    if (tenantSlug) {
      headers["X-Tenant-Slug"] = tenantSlug;
    }
  }

  config.headers = headers;
  return config;
});